import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import InputMask from 'react-input-mask'
import moment from 'moment'

import styles from './styles.css'

class DatetimeInput extends PureComponent {
  static propTypes = {
    value: PropTypes.any,
  }

  static defaultProps = {
    value: moment(),
  }

  state = {
    input: '',
    oldInput: '',
  }

  componentDidMount() {
    const { value } = this.props
    this.setInitialValue(value)
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps
    this.setInitialValue(value)
  }

  setInitialValue = date => {
    if (date) {
      const input = this.dateToString(date)
      this.setState({
        input,
        oldInput: input,
      })
    }
  }

  handleInputChange = event => {
    const { value } = event.currentTarget
    const { onChange } = this.props
    const validDate = this.stringToDate(value)
    onChange(validDate)

    this.setState({
      input: validDate,
    })
  }

  stringToDate = string => {
    const { oldInput } = this.state
    const date = moment(string, 'MM/DD/YYYY HH:mm')

    if (this.validateDate(date)) {
      this.setState({
        oldInput: date,
      })
      return date
    }

    return oldInput
  }

  dateToString = date => moment(date).format('MM/DD/YYYY HH:mm')

  validateDate = date => date.isValid() && date.isSameOrBefore(moment(), 'second')

  render() {
    const { input } = this.state
    const { ...props } = this.props
    return (
      <InputMask
        {...props}
        value={input}
        onChange={this.handleInputChange}
        mask="99/99/9999 99:99"
        maskChar="-"
        alwaysShowMask={false}
      />
    )
  }
}

export default DatetimeInput



// WEBPACK FOOTER //
// ./src/components/datetimeInput/index.js